import { css } from "@emotion/react";
import {
  blackBaseButtonStyle,
  whiteBaseButtonStyle,
} from "pages/AccountSettlementHistoryOrderId/styles/commonStyles";

export const blackActionButtonStyle = css`
  ${blackBaseButtonStyle}
  width: 328px;
`;

export const skeletonButtonStyle = css`
  ${blackBaseButtonStyle}
  width: 328px;
  background: linear-gradient(90deg, #333 25%, #555 50%, #333 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  pointer-events: none;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const whiteActionButtonStyle = css`
  ${whiteBaseButtonStyle}
  width: 328px;
`;
